import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-warm-light text-warm-dark pt-16 pb-12 border-t border-warm-sand">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 pb-12 border-b border-warm-sand">
          {/* Column 1: Brand & CVR */}
          <div className="flex flex-col gap-2">
            <Link to="/" className="flex flex-col group">
              <span className="font-display text-2xl tracking-wide text-warm-dark group-hover:text-warm-gray transition-colors duration-300">
                Solveig Juliane Tousgaard
              </span>
              <span className="text-[10px] uppercase tracking-[0.2em] text-warm-gray font-medium">
                Familie- & Psykoterapeut MPF
              </span>
            </Link>
            <div className="text-xs text-warm-gray/60 mt-2">
              CVR: 32976859
            </div>
          </div>

          {/* Column 2: Quick Links */}
          <div className="flex flex-col gap-4">
            <h4 className="text-xs uppercase tracking-[0.2em] text-warm-gray font-semibold">
              Hurtige links
            </h4>
            <nav className="flex flex-col gap-2.5 text-sm">
              <Link to="/" className="text-warm-gray/80 hover:text-warm-dark transition-colors duration-200">
                Forside
              </Link>
              <Link to="/om-solveig" className="text-warm-gray/80 hover:text-warm-dark transition-colors duration-200">
                Om Solveig
              </Link>
              <Link to="/terapi" className="text-warm-gray/80 hover:text-warm-dark transition-colors duration-200">
                Individuel Terapi
              </Link>
              <Link to="/terapi/familiebehandling" className="text-warm-gray/80 hover:text-warm-dark transition-colors duration-200">
                Familiebehandling
              </Link>
              <Link to="/terapi/parterapi" className="text-warm-gray/80 hover:text-warm-dark transition-colors duration-200">
                Parterapi
              </Link>
              <Link to="/terapi/traumer-og-seksuelle-overgreb-i-barndommen" className="text-warm-gray/80 hover:text-warm-dark transition-colors duration-200">
                Traumer & Overgreb
              </Link>
              <Link to="/terapi/akut-terapi" className="text-warm-gray/80 hover:text-warm-dark transition-colors duration-200">
                Akut Terapi
              </Link>
            </nav>
          </div>

          {/* Column 3: Contact Info */}
          <div className="flex flex-col gap-4">
            <h4 className="text-xs uppercase tracking-[0.2em] text-warm-gray font-semibold">
              Kontaktoplysninger
            </h4>
            <div className="flex flex-col gap-3 text-sm text-warm-gray/80">
              <div className="flex items-start gap-3">
                <i className="fa-light fa-location-dot mt-1 text-warm-gray/60" />
                <span>
                  Møgelvænget 4<br />
                  5500 Middelfart
                </span>
              </div>
              <div className="flex items-center gap-3">
                <i className="fa-light fa-phone text-warm-gray/60" />
                <a 
                  href="tel:23369087" 
                  className="hover:text-warm-dark transition-colors duration-200 whitespace-nowrap"
                >
                  Tlf: 23 36 90 87
                </a>
              </div>
              <div className="flex items-center gap-3">
                <i className="fa-light fa-envelope text-warm-gray/60" />
                <a 
                  href="mailto:solveig.tousgaard@gmail.com" 
                  className="hover:text-warm-dark transition-colors duration-200 whitespace-nowrap"
                >
                  solveig.tousgaard@gmail.com
                </a>
              </div>
              <div className="flex items-center gap-3 pt-1 border-t border-warm-sand/30 mt-1">
                <i className="fa-brands fa-facebook text-warm-gray/60" />
                <a 
                  href="https://www.facebook.com" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="hover:text-warm-dark transition-colors duration-200"
                >
                  Følg på Facebook
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Area: Copyright & Association Logo */}
        <div className="pt-8 flex flex-col sm:flex-row items-center justify-between gap-6">
          <div className="text-xs text-warm-gray/60 text-center sm:text-left">
            &copy; {currentYear} Familie og Psykoterapeut MPF Solveig Juliane Tousgaard. Alle rettigheder forbeholdes.
          </div>
          
          {/* Association Logo */}
          <div className="flex flex-col items-center sm:items-end gap-2">
            <span className="text-[10px] uppercase tracking-[0.15em] text-warm-gray/50 font-medium">
              Medlem af
            </span>
            <img 
              src="https://assets.auxodev.dk/cdn-cgi/image/width=160,quality=90,format=auto/assets/03b9ae14-e37a-4264-bc6f-37708de40179/skaermbillede-2025-03-03-kl-09-55-27.png" 
              alt="Medlem af Dansk Psykoterapeutforening MPF" 
              className="h-12 w-auto opacity-90 hover:opacity-100 transition-opacity duration-300 object-contain"
            />
          </div>
        </div>
      </div>
    </footer>
  );
}
